var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNpNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m87.5 62.5v-25c0-9.9453-3.9492-19.484-10.984-26.516-7.0312-7.0352-16.57-10.984-26.516-10.984s-19.484 3.9492-26.516 10.984c-7.0352 7.0312-10.984 16.57-10.984 26.516v25c-6.9023 0-12.5 5.5977-12.5 12.5s5.5977 12.5 12.5 12.5h21.418c1.2852 4.7422 4.6016 8.6719 9.0547 10.742 4.457 2.0703 9.5977 2.0703 14.055 0 4.4531-2.0703 7.7695-6 9.0547-10.742h21.418c6.9023 0 12.5-5.5977 12.5-12.5s-5.5977-12.5-12.5-12.5zm-37.5 29.168c-2.9727-0.003907-5.7227-1.5938-7.207-4.168h14.418-0.003907c-1.4844 2.5742-4.2344 4.1641-7.207 4.168zm37.5-12.5h-75c-2.3008 0-4.168-1.8672-4.168-4.168s1.8672-4.168 4.168-4.168h8.332v-33.332c0-7.7344 3.0742-15.152 8.543-20.625 5.4727-5.4688 12.891-8.543 20.625-8.543s15.152 3.0742 20.625 8.543c5.4688 5.4727 8.543 12.891 8.543 20.625v33.332h8.332c2.3008 0 4.168 1.8672 4.168 4.168s-1.8672 4.168-4.168 4.168z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpNotification);
export default __webpack_public_path__ + "static/media/np_notification.dee53b40854b6b66a0f40469baf7722d.svg";
export { ForwardRef as ReactComponent };